import { useState } from 'react';

import { canonBreakers, isCanonBreaker } from 'utils/canonBreakers';
import { getThumbnailUrl } from 'utils/BreakerImageAPI';

const homepageBreakers = [1119, 833, 1146, 1106, 926, 845, 908, 945, 912, 1047].map((id) => {
  const isCanon = isCanonBreaker(id);
  return {
    id,
    imageUrl: getThumbnailUrl(id),
    name: isCanon ? canonBreakers[id].name : `Breaker #${id}`,
    isCanonBreaker: isCanon,
  };
});

const useBreakerCarousel = () => {
  const [breakers] = useState(homepageBreakers);

  return {
    breakers,
  };
};

export default useBreakerCarousel;
